<template lang="pug">
.family-message-history-detail-message-register-detail-accordion
  b-card-header#message-detail.p-2(header-tag="header" role="tab" header-class="accordion-toggle" v-b-toggle.accordion-message-detail)
    span.toggle-text メッセージの内容
  b-collapse#accordion-message-detail(accordion="message-detail-accordion" role="tabpanel")
    b-card-body.p-2
      AccordionLoading(:isBusy="isBusy")
      MessageRegisterDetail(v-show="!isBusy" v-model="messageDetail")
</template>

<script lang="ts">
import { Component, Inject, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore } from "@/store/store";
import { MobileMessageHistoryState } from "@/store/MobileMessageHistory";
import Setting from "../../../../public/setting.json";

import S3UrlService from "@/commons/services/S3Url";

import MessageRegisterDetail, { MessageRegisterDetailModel } from "@/mobile/components/MessageRegisterDetail.vue";
import AccordionLoading from "@/mobile/basics/AccordionLoading.vue";

/**
 * ### 送信履歴詳細(施設関係者)送信メッセージの詳細アコーディオン
 */
@Component({
  components: {
    AccordionLoading,
    MessageRegisterDetail
  }
})
export default class MessageDetailAccordion extends Vue {
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;

  /** ### 新規送信入力画面での入力情報 */
  @Getter("mobileMessageHistoryState") state!: MobileMessageHistoryState;

  /** ローディングの表示可否 */
  isBusy: boolean = false;
  /** メッセージ詳細 */
  messageDetail: MessageRegisterDetailModel | any = {};

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    await this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   *
   * - メッセージの内容を表示するコンポーネント用の情報を作成する
   */
  public async createView(): Promise<void> {
    this.isBusy = true;

    // メッセージの内容を表示するコンポーネント用の情報を作成する
    const files: Array<File> = await this.getFileUrls();
    const messageDetail: MessageRegisterDetailModel = this.createMessageDetail(this.state, files);
    this.messageDetail = messageDetail;

    this.isBusy = false;

    return;
  }
  /**
   * ### プレビュー用のファイルを取得する
   *
   * - fileUrlはS3に格納されているファイルのURLのためFileとして取得して配列で返す
   */
  public async getFileUrls(): Promise<Array<File>> {
    const contents: any = this.state.functionContents;
    let files: Array<File> = [];
    if (contents.fileUrls) {
      for (let fileUrl of contents.fileUrls) {
        const file: File = await this.getS3File(fileUrl);
        files.push(file);
      }
    }

    return files;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  public async getS3File(url: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url);

    return response;
  }

  /**
   * ### 送信メッセージ表示コンポーネントに渡す情報を作成する
   */
  public createMessageDetail(state: MobileMessageHistoryState, files: Array<File>): MessageRegisterDetailModel {
    const messageDetail: MessageRegisterDetailModel = {
      receivers: state.receivers,
      isSharedMessages: state.isSharedMessages,
      title: state.functionContents.title,
      text: state.functionContents.content,
      addReadButton: state.functionContents.addReadButton,
      addOptionText: state.functionContents.addOptionText,
      addReplyButton: state.functionContents.addReplyButton,
      files: files
    };

    return messageDetail;
  }
}
</script>
